import { render } from "./PdfReader.vue?vue&type=template&id=5f52d242"
import script from "./PdfReader.vue?vue&type=script&lang=js"
export * from "./PdfReader.vue?vue&type=script&lang=js"

import "./PdfReader.vue?vue&type=style&index=0&id=5f52d242&lang=scss"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__